import React, { Component } from 'react'
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
    MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon, MDBFormInline, Link
} from "mdbreact";
import { Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Avatar  } from 'antd';
import { URL } from '../api';
import ban from '../img/math.png'


export default class Header extends Component {

    state = {
        isOpen: false,
        nameuser: '',
        admin_type: '',
        Username: '',
    };

    toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') !== "") {
          this.setState({ nameuser: localStorage.getItem('nameuser') })
          this.setState({ admin_type: localStorage.getItem('admin_type') })
        } else {
             
            this.setState({ admin_type: 'public' })
          //  window.location.href = 'https://scitech.kpru.ac.th/csrm2025/system'
        }

        const date = new Date();
        const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
        const dates = day+"-"+month+"-"+year ;


        const dateFrom = "01-08-2024";
        const dateTo = "31-09-2024";
        const dateCheck = dates;

        const d1 = dateFrom.split("-");
        const d2 = dateTo.split("-");
        const c = dateCheck.split("-");

        const from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
        const to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
        const check = new Date(c[2], parseInt(c[1])-1, c[0]);

        console.log(check > from && check < to)

        if (check > from && check < to === false) {
          localStorage.setItem('dateCheck', false)
        }else{
          localStorage.setItem('dateCheck', true)
        }


      }


      logout() {
      //   localStorage.removeItem(('admin_type'))
       //  localStorage.removeItem(('nameuser'))
        localStorage.clear();
    
        setTimeout(() => {
          window.location.href = 'https://kprupsf.kpru.ac.th/'
          // window.location.href = '/'
        }, 1000);
       // this.setState({ admin_type: 'public' }
        message.success("ออกจากระบบแล้ว")
      }


  





    render() {

      const url = window.location.pathname;
      console.log(url)

        let logout
        logout = (
          <>
            <MDBNavItem>
              <MDBNavLink to="/main"> {this.state.nameuser}</MDBNavLink>
    
            </MDBNavItem>
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/adminconference-sd">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    
        let superadmin
        superadmin = (
          <>
           <MDBNavItem >
                 <MDBNavLink to="/superadminhome"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
              <MDBNavItem >
                 <MDBNavLink to="/superadminlistregister"><MDBIcon icon="users" /> ข้อมูลผู้ลงทะเบียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadminlistartical"><MDBIcon icon="layer-group" /> บทความแต่ละกลุ่ม</MDBNavLink>
            </MDBNavItem>
           {/* <MDBNavItem >
                 <MDBNavLink to="/superadmincheckpayment"><MDBIcon icon="file-alt" /> บทความอยู่ระหว่างการชำระเงิน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadmin"><MDBIcon icon="file-alt" /> บทความชำระเงินเแล้ว</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem >
                 <MDBNavLink to="/superadminsucceed"><MDBIcon icon="clipboard-check" /> บทความผ่านเแล้ว</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadminsucceedsm"><MDBIcon icon="clipboard-check" /> บทความสัมมนา</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/expertbnforgotpassword"><MDBIcon icon="atlas" /> ลืมรหัสผ่าน</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/superadmininside"><MDBIcon far icon="chart-bar" />สัดส่วนบทความ</MDBNavLink>
            </MDBNavItem> */}
            {/* <MDBNavItem >
                 <MDBNavLink to="/superadminstatus"><MDBIcon icon="home" /> สถานะบทความ</MDBNavLink>
            </MDBNavItem> */}
          
            {/* <MDBNavItem >
                 <MDBNavLink to="/superadminaddress"><MDBIcon icon="home" /> ที่อยู่</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadmincertificate"><MDBIcon icon="home" /> จัดการเกียรติบัตร</MDBNavLink>
            </MDBNavItem> */}
             {/* <MDBNavItem >
                 <MDBNavLink to="/superadminlistexpert"><MDBIcon icon="home" /> จัดการผู้ทรงคุณวุฒิ</MDBNavLink>
            </MDBNavItem>
               <MDBNavItem >
                 <MDBNavLink to="/superadminlistexpertbn"><MDBIcon icon="home" /> จัดการบรรณาธิการ</MDBNavLink>
            </MDBNavItem> */}

            <MDBNavItem  >
              <MDBDropdown  >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="cog" /> ตั้งค่า/จัดการ</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu  class="dropdown-content" >
                <Link to="/superadminlistexpert" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="user-secret" /> จัดการผู้ทรงคุณวุฒิ</MDBDropdownItem></Link>
                <Link to="/superadminlistexpertbn">  <MDBDropdownItem className='bgcolormenu2 text-dake' ><MDBIcon icon="user" /> จัดการบรรณาธิการ</MDBDropdownItem></Link>
                <Link to="/superadminmanage">  <MDBDropdownItem className='bgcolormenu2 text-dake' ><MDBIcon icon="user" /> จัดการผู้ดูแลระบบ</MDBDropdownItem></Link>
                <Link to="/superadmintypemanage">  <MDBDropdownItem className='bgcolormenu2 text-dake' ><MDBIcon icon="bars" /> จัดการประเภทนำเสนอ</MDBDropdownItem></Link>
                <Link to="/Superadminroom" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> จัดการห้อง</MDBDropdownItem></Link>
                <Link to="/Superadminuniversity" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> จัดการข้อมูลมหาลัย</MDBDropdownItem></Link>
                <Link to="/Superadmindateopen" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> จัดการวันเปิด-ปิด</MDBDropdownItem></Link>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>

            <MDBNavItem >
              <MDBDropdown >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="cog" /> ตั้งค่า/ส่วนนำเสนอ</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu  class="dropdown-content" >
              
                <Link to="/Superadminroompresent" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> เพิ่มห้องนำเสนอ/บทความ/ผู้ทรงคุณวุฒิ</MDBDropdownItem></Link>
                <Link to="/Superadminroompresentsm" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> เพิ่มห้องนำเสนอสัมมนา/บทความสัมมนา/ผู้ทรงคุณวุฒิ</MDBDropdownItem></Link>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>

            <MDBNavItem >
              <MDBDropdown >
                    <MDBDropdownToggle nav caret>
                      <span className="mr-2"><MDBIcon icon="book" /> รายงาน</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu  class="dropdown-content" >
                    <Link to="/Superadminreportscoolroompresent" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> รายงานคะแนนแต่ละห้องนำเสนอ/เพิ่มรางวัล (โครงงาน)</MDBDropdownItem></Link>
                    <Link to="/Superadminreportscoolroompresentsm" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> รายงานคะแนนแต่ละห้องนำเสนอ/เพิ่มรางวัล (สัมมนา)</MDBDropdownItem></Link>
                    <Link to="/Superadminprintregisteruniversity" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> พิมพ์ใบเซ็นชื่อแต่ละมหาวิทยาลัย</MDBDropdownItem></Link>
                    </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>

          



             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" /> ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )

        let admintype
        admintype = (
          <>
           {/* <MDBNavItem >
                 <MDBNavLink to="/superadmincheckpayment"><MDBIcon icon="file-alt" /> ตรวจสอบการชำระเงิน</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem >
                 <MDBNavLink to="/superadmincheckadmintype"><MDBIcon icon="file-alt" /> บทความเข้าใหม่</MDBNavLink>
            </MDBNavItem>
          
            <MDBNavItem >
                 <MDBNavLink to="/superadminlistregister"><MDBIcon icon="home" /> ข้อมูลผู้ลงทะเบียน</MDBNavLink>
            </MDBNavItem>
           
            <MDBNavItem  >
              <MDBDropdown  >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="book" /> ตั้งค่า/จัดการ</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu  class="dropdown-content" >
                <Link to="/superadminlistexpert" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> จัดการผู้ทรงคุณวุฒิ</MDBDropdownItem></Link>
                <Link to="/superadminlistexpertbn">  <MDBDropdownItem className='bgcolormenu2 text-dake' ><MDBIcon icon="city" /> จัดการบรรณาธิการ</MDBDropdownItem></Link>
                  {/* <Link to="/superadminmanage">  <MDBDropdownItem className='bgcolormenu2 text-dake' ><MDBIcon icon="city" /> จัดการผู้ดูแลระบบ</MDBDropdownItem></Link>
                  <Link to="/superadmintypemanage">  <MDBDropdownItem className='bgcolormenu2 text-dake' ><MDBIcon icon="city" /> จัดการประเภทนำเสนอ</MDBDropdownItem></Link> */}
               
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>

             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" /> ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
        

        let adminfaculty
        adminfaculty = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/adminfaculty"><MDBIcon icon="home" /> สถานะบทความคณะ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/adminfacultyproportion"><MDBIcon icon="home" /> สัดส่วนบทความ</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/superadmincertificate"><MDBIcon icon="home" /> จัดการเกียรติบัตร</MDBNavLink>
            </MDBNavItem>
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )


        let expert
        expert = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/expertexpsf"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
              <MDBNavItem >
                 <MDBNavLink to="/expertexpsfedit"><MDBIcon icon="home" /> ผลงานรอปรับแก้ไข</MDBNavLink>
            </MDBNavItem>
                 <MDBNavItem >
                 <MDBNavLink to="/expertexpsfsuccess"><MDBIcon icon="home" /> ประวัติการตรวจผลงาน</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expertbnbackex"><MDBIcon icon="home" /> บทความปรับแก้หลังจากผู้ทรงพิจารณา</MDBNavLink>
            </MDBNavItem> */}

             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"> <MDBIcon icon="sign-out-alt" /> ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )

        let expertpresent
        expertpresent = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/expertpresent"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expertbnbackex"><MDBIcon icon="home" /> บทความปรับแก้หลังจากผู้ทรงพิจารณา</MDBNavLink>
            </MDBNavItem> */}

             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"> <MDBIcon icon="sign-out-alt" /> ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )

        let expertpresentsm
        expertpresentsm = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/expertpresent"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expertbnbackex"><MDBIcon icon="home" /> บทความปรับแก้หลังจากผู้ทรงพิจารณา</MDBNavLink>
            </MDBNavItem> */}

             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"> <MDBIcon icon="sign-out-alt" /> ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )


        let expertbn
        expertbn = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/expertbn"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/expertex"><MDBIcon icon="atlas" /> คณะกรรมการตรวจ</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expertbnforgotpassword"><MDBIcon icon="atlas" /> ลืมรหัสผ่าน</MDBNavLink>
            </MDBNavItem>
            

            <MDBNavItem  >
              <MDBDropdown  >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="book" /> ตั้งค่า/จัดการ</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu  class="dropdown-content" >
                <Link to="/superadminlistexpert" > <MDBDropdownItem className='bgcolormenu1 text-dake' ><MDBIcon icon="door-closed" /> จัดการผู้ทรงคุณวุฒิ</MDBDropdownItem></Link>
              
               
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem> */}

            {/* <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> สัดส่วนบทความvvvvvv</MDBNavLink>
            </MDBNavItem> */}
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"> <MDBIcon icon="sign-out-alt" /> ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )


        let publics
        publics = (
          <>
            <MDBNavItem  >
              <MDBNavLink to="/">   เข้าสู่ระบบ </MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem  >
              <MDBNavLink to="/Register">  ลงทะเบียน </MDBNavLink>
            </MDBNavItem> */}
          </>
        )


        let user
        user = (
          <>
           <MDBNavItem  >
              <MDBNavLink to="/Homeuser"><MDBIcon fas icon="align-justify"  />  หน้าหลัก </MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem  >
              <MDBNavLink to="/Homeusersm"><MDBIcon fas icon="atlas" /> เพิ่มบทความสัมมนา </MDBNavLink>
            </MDBNavItem> */}
{/*             
            {localStorage.getItem('register_typemamber')=== '3' || localStorage.getItem('register_typemamber')=== '4' || localStorage.getItem('register_typemamber')=== '5' || localStorage.getItem('register_typemamber')=== '6' ?<>
            
             <MDBNavItem  >
              <MDBNavLink to="/Homeuserlisten"><MDBIcon fas icon="headphones" />  ลงทะเบียนเข้าร่วมฟัง </MDBNavLink>
            </MDBNavItem>
            </> :<></> } */}
           
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon fas icon="sign-out-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          
    
    
          </>
        )

      //  const params = useParams()
     //   const [searchParams] = useSearchParams();

      //  console.log(searchParams);

   

      

        return (
            <>
               {this.state.admin_type !== null ? <>
                {/* <img src={ban} className="rounded mx-auto " alt="aligment" /> */}
               </>:<></>}
               
                <MDBNavbar color="orange" dark expand="md">
                    <MDBNavbarBrand>
                        <strong className="white-text"><Avatar src="https://ga.kpru.ac.th/governance/img/logo.png" /> KPRU-PSF</strong>
                      
                    </MDBNavbarBrand>
                    <MDBNavbarToggler onClick={this.toggleCollapse} />
                    <MDBCollapse id="navbarCollapse3" onCollapse={(e)=>{console.log(e)}} isOpen={this.state.isOpen}  navbar>
                        <MDBNavbarNav left>

                            {/* <MDBNavItem >
                                <MDBNavLink to="/"><MDBIcon icon="home" /> Home</MDBNavLink>
                            </MDBNavItem> */}

                       

                          {this.state.admin_type !== null ? <>
                            
                           {this.state.admin_type === 'admin' ? <>
                            {superadmin}
                            </> : null}

                            {this.state.admin_type === 'admintype' ? <>
                            {admintype}
                            </> : null}

                            {this.state.admin_type === 'expert' ? <>
                            {expert}
                            </> : null}

                            {this.state.admin_type === 'expertbn' ? <>
                            {expertbn}
                            </> : null}

                             {this.state.admin_type === 'expertpresent' ? <>
                            {expertpresent}
                            </> : null}

                            {this.state.admin_type === 'expertpresentsm' ? <>
                            {expertpresentsm}
                            </> : null}

                           

                            {this.state.admin_type === '4' ? <>
                            {adminfaculty}
                            </> : null}  

                            {this.state.admin_type === 'user' ? <>
                            {user}
                            </> : null}  

                            </> : <>{publics}</>}  

                        </MDBNavbarNav>
                        <MDBNavbarNav right>
                            <MDBNavItem>
                                <MDBFormInline waves>
                           
                                    {/* <div className="md-form my-0">
                                        <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
                                    </div> */}
                                       {/* <img src={ban} className="rounded mx-auto d-block w-25" alt="aligment" /> */}
                                </MDBFormInline>
                            </MDBNavItem>
                        </MDBNavbarNav>
                        </MDBCollapse>
                </MDBNavbar>
                {/* <img src={ban} className="rounded mx-auto d-block w-25" alt="aligment" /> */}
                {/* <img src={ban} className="rounded mx-auto " alt="aligment" /> */}
               

            </>
        )
    }
}

